import { forwardRef } from "react";
import { useId } from "react";
function SvgRawTwitterIcon({ title, titleId, ...props }, ref) {
  const id = useId();
  const toAppend = "_" + id;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="currentColor"
        d="M25.543 10.979c.015.217.015.434.015.653 0 6.673-4.953 14.368-14.01 14.368v-.004A13.686 13.686 0 0 1 4 23.732c.389.048.78.072 1.172.073a9.732 9.732 0 0 0 6.115-2.166c-2.107-.04-3.954-1.45-4.6-3.506a4.79 4.79 0 0 0 2.223-.087c-2.297-.476-3.95-2.546-3.95-4.95v-.064a4.8 4.8 0 0 0 2.235.632C5.032 12.18 4.365 9.229 5.671 6.92c2.5 3.155 6.189 5.073 10.148 5.276a5.136 5.136 0 0 1 1.425-4.825 4.843 4.843 0 0 1 6.966.22 9.732 9.732 0 0 0 3.127-1.227 5.049 5.049 0 0 1-2.165 2.793A9.603 9.603 0 0 0 28 8.363a10.149 10.149 0 0 1-2.457 2.616Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawTwitterIcon);
export default ForwardRef;
